import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { getRoleLabel } from "../../constants/plans";

export const ProfileSection = ({
  formData,
  setFormData,
  currentUser,
  loading,
  hasProfileChanges,
  handleSubmit,
}) => (
  <div className="bg-background rounded-lg p-6 mb-6">
    <h2 className="text-xl font-bold mb-4">Información personal</h2>
    <form
      onSubmit={handleSubmit}
      className="space-y-4"
      data-testid="account-settings-form"
    >
      <div>
        <label className="text-sm font-medium mb-2 block">Nombre</label>
        <Input
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          data-testid="account-name-input"
        />
      </div>
      <div>
        <label className="text-sm font-medium mb-2 block">Email</label>
        <Input
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          data-testid="account-email-input"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Al cambiar el correo, usarás esa dirección en tu siguiente inicio de sesión.
        </p>
      </div>
      <div>
        <label className="text-sm font-medium mb-2 block">Rol</label>
        <Input
          value={getRoleLabel(currentUser?.role)}
          disabled
          className="bg-muted"
          data-testid="account-role-input"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-3 pt-2">
        <Button
          type="submit"
          disabled={loading || !hasProfileChanges}
          className="w-full sm:w-auto"
          data-testid="save-profile-button"
        >
          {loading ? "Guardando..." : "Guardar cambios"}
        </Button>
      </div>
    </form>
  </div>
);
